var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4ba2dac473"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.265625 0 L 22.507812 0 L 22.507812 29 L 7.265625 29 Z M 7.265625 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ba2dac473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--text)",
    d: "M 7.636719 28.597656 C 7.820312 28.78125 8.0625 28.875 8.300781 28.875 C 8.542969 28.875 8.785156 28.78125 8.96875 28.597656 L 22.140625 15.238281 C 22.507812 14.867188 22.507812 14.261719 22.140625 13.890625 L 8.96875 0.53125 C 8.597656 0.160156 8.003906 0.160156 7.636719 0.53125 C 7.269531 0.902344 7.269531 1.507812 7.636719 1.878906 L 20.144531 14.5625 L 7.636719 27.246094 C 7.269531 27.621094 7.269531 28.222656 7.636719 28.597656 Z M 7.636719 28.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.85fa6b8cef05b15c297dab4b08c48c6a.svg";
export { ForwardRef as ReactComponent };